import React from "react";
import { Icon, Menu } from "semantic-ui-react";

export function MenuItem({ active, icon, name, label, onClick }) {
  const color = active ? "active" : undefined;

  return (
    <Menu.Item className={color} onClick={onClick} name={name}>
      {typeof icon === "string" ? <Icon name={icon} /> : icon}

      <br />
      <div>{label}</div>
    </Menu.Item>
  );
}
